import type { FaIconSize } from '../types';

export type FaIconProps = {
  icon: string;
  cssClass?: string;
  size?: FaIconSize;
};

const FA_SIZE_CLASS: Record<FaIconSize, string> = {
  xxs: 'fa-2xs',
  xs: 'fa-xs',
  sm: 'fa-sm',
  md: '',
  lg: 'fa-lg',
  xl: 'fa-xl',
  xxl: 'fa-2xl',
};

export function FaIcon({ icon, cssClass, size = 'lg' }: FaIconProps) {
  return <i className={`${icon} ${FA_SIZE_CLASS[size]} ${cssClass ?? ''}`}></i>;
}
